import { Outlet, createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { MobileBlocker } from '../../../../../components/mobile-blocker';
import { trackError } from '../../../../../error/tracking';
import { captureException } from '../../../../../logger/capture-exception';
import { Feature, isFeatureAvailable } from '../../../../../shared/feature';
import { usePostHogSessionRecording } from '../../../../../shared/hooks/use-posthog-session-recording';
import { HeaderProductFunnel, StepType } from './-components/header-product-funnel';

export const Route = createFileRoute('/app/funnel/product/$id/_layout-funnel')({
  // eslint-disable-next-line no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  usePostHogSessionRecording();

  useEffect(
    function () {
      if (!isFeatureAvailable(Feature.PRODUCT)) {
        navigate({ to: '/app/blogs' }).catch(function (err) {
          captureException(
            err,
            {
              file: 'src/routes/app/funnel/product/$id/_layout-funnel.tsx',
              method: 'navigate',
              infoMessage: 'unable to navigate to /app/blogs',
            },
            trackError
          );
        });
      }
    },
    [navigate]
  );
  // TODO: Check product is valid or groupId is valid and status is not fully done, if not redirect to /app or to product page
  return (
    <>
      <MobileBlocker />
      <div className="relative h-full w-full overflow-auto bg-white py-20">
        <HeaderProductFunnel
          onClose={function () {
            // TODO: Check if product is saved before navigating away
            navigate({ to: '/app/products' }).catch(function (err) {
              captureException(
                err,
                {
                  file: 'app.product.$id.tsx',
                  method: 'navigate',
                  infoMessage: `unable to navigate to /app/products`,
                },
                trackError
              );
            });
          }}
          type={StepType.BULK_IMPORT}
        />
        <div className="mx-auto max-w-content overflow-hidden pt-10">
          <Outlet />
        </div>
      </div>
    </>
  );
}
